import React from "react";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import PersonalInfo from "./PersonalInfo";
import Password from "./Password";
import "./PersonalSettings.css";
import { Helmet } from "react-helmet";
import { UserContext } from "../index";
var PersonalSettings = function PersonalSettings(props) {
  var _React$useContext = React.useContext(UserContext),
    user = _React$useContext.user;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("title", null, "Workfolio | Personal Settings | ".concat(user === null || user === void 0 ? void 0 : user.displayName))), /*#__PURE__*/React.createElement("div", {
    className: "personal-settings personal-setting-root"
  }, /*#__PURE__*/React.createElement(Tabs, {
    defaultActiveKey: 1
  }, /*#__PURE__*/React.createElement(Tab, {
    eventKey: 1,
    title: "Info"
  }, /*#__PURE__*/React.createElement(PersonalInfo, props)), /*#__PURE__*/React.createElement(Tab, {
    eventKey: 2,
    title: "Password"
  }, /*#__PURE__*/React.createElement(Password, {
    user: user
  })))));
};
export default PersonalSettings;